import firebase from '../firebase'

const storage = firebase.storage().ref('redvolucion/inspirados')
const storageDocumentos = firebase.storage().ref('redvolucion/documentos')

const obtenerUrlArchivoPorNombre = (nombreArchivo, dni) => {
  return storage.child(`${dni}/${nombreArchivo}`).getDownloadURL()
}

const obtenerUrlDocumentoPorNombre = (nombreArchivo, dni) => {
  return storageDocumentos.child(`${dni}/${nombreArchivo}`).getDownloadURL()
}

const guardarArchivoBase64 = (archivo, dni) => {
  return storage.child(`${String(dni)}/${archivo.originalName}`).putString(archivo.url, 'data_url')
}

const guardarDocumentoBase64 = (archivo, dni) => {
  return storageDocumentos.child(`${String(dni)}/${archivo.originalName}`).putString(archivo.url, 'data_url')
}

export default {
  obtenerUrlArchivoPorNombre,
  guardarArchivoBase64,
  guardarDocumentoBase64,
  obtenerUrlDocumentoPorNombre
}
